/**
 * MessageText · 用户文字气泡（v4 仅渲染 user 消息）
 *
 * v4 改动：AI 气泡由 MessageAssistant 负责，本组件只渲染 user。
 * 静态欢迎气泡由 ChatFeed 直接 inline 渲染（不走本组件）。
 *
 * 「重新发起这一轮」按钮 · hover 气泡时显示
 *  · 调用 regenerateFromUserMessage(id, content) 截断本消息及其后所有，
 *    再用同样文案重发 → 新一轮 SSE
 *  · streaming 期间 ChatActions 内部会自动忽略，前端不另外做 disabled 视觉
 */

import React from 'react'
import classNames from 'classnames'
import { Tooltip } from 'antd'
import { ReloadOutlined, UserOutlined } from '@ant-design/icons'
import type { TextMessage } from '../../../../../../types/ai-classify'
import { useChatActions } from '../../ChatActionsContext'
import styles from './MessageText.module.scss'

export interface MessageTextProps {
  message: TextMessage
}

const MessageText: React.FC<MessageTextProps> = ({ message }) => {
  const { regenerateFromUserMessage } = useChatActions()
  const handleRegenerate = (e: React.MouseEvent): void => {
    e.stopPropagation()
    regenerateFromUserMessage(message.id, message.content)
  }
  return (
    <div className={classNames(styles.message, styles.user)}>
      <div className={styles.header}>
        <div
          className={classNames(styles.avatar, styles.avatarUser)}
          aria-hidden
        >
          <UserOutlined />
        </div>
        <span className={styles.roleName}>我</span>
      </div>
      <div className={styles.content}>{message.content}</div>
      {/* hover 时露出 · 单按钮"重新发起" · 不抢主视觉，与 AI 气泡的反馈区呼应 */}
      <div className={styles.actions}>
        <Tooltip title="重新发起这一轮" placement="top">
          <button
            type="button"
            className={styles.actionBtn}
            onClick={handleRegenerate}
            onMouseDown={(e) => e.preventDefault()}
            aria-label="重新发起这一轮"
          >
            <ReloadOutlined />
          </button>
        </Tooltip>
      </div>
    </div>
  )
}

export default MessageText
